<!--
@Author: MIYONGLE
@Desc: 关于我们 - 联系我们
@Date: 2021-07-29 13时
-->
<template>
  <div>
    <!-- 办公地点 -->
    <span class="title-txt">办公地点</span>

    <!-- 列表 -->
    <div class="contact-us clearfix">
      <div class="contact-us-item" v-for="(item,index) of addressList" :key="index">
        <div>
          <img :src='item.src' alt="慧用工"/>
          <span class="contact-us-title">{{item.title}}</span>
          <span class="contact-us-desc" v-html="item.desc"></span>
        </div>
      </div>
    </div>

    <!-- 咨询热线 -->
    <div class="zx-sec">
      <div class="zx-sec-con">

        <div class="zx-sec-block">
          <img src="../../../static/mobile/aboutUs/aboutus_icon_tel.png" alt="">
          <div>
            <span>咨询热线</span>
            <span>400-085-5500</span>
          </div>
        </div>

        <div class="zx-sec-block">
          <img src="../../../static/mobile/aboutUs/aboutus_icon_mail.png" alt="">
          <div>
            <span>联系邮箱</span>
            <span>market@hvyogo.com</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import {OFFICE_LOCATION} from '../../service/businessConsts'
export default {
  name: "mContact-us",
  data() {
    return {
      addressList: OFFICE_LOCATION
    }
  },
  components: {
  },
  created() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
// 标题
.title-txt{
  color: #100F0F;
  margin-top: 103px;
  margin-bottom: 35px;
}

// 列表
.contact-us{
  padding: 0 30px;
  box-sizing: border-box;
  width: 100%;
  
  .contact-us-item:nth-child(even){
    padding-left: 9px;
  }
  .contact-us-item:nth-child(odd){
    padding-right: 9px;
  }
  .contact-us-item{
    width: 50%;
    box-shadow: 0px 24px 72px -12px rgba(25, 133, 255, 0.1);
    border-radius: 10px;
    float:left;
    padding-bottom: 36px;
    height: 468px;
    box-sizing: border-box;
    margin-bottom: 20px;
    div{
      background: #fff;

      img{
        margin: 0 auto;
        width: 100%;
        height: 256px;
      }
      span{
        display: block;
      }

      .contact-us-title{
        color: #100F0F;
        font-size: 22px;
        font-weight: bolder;
        line-height: 30px;
        margin-top: 36px;
        margin-bottom: 20px;
      }
      .contact-us-desc{
        color: #100F0F;
        font-size: 22px;
        width: 268px;
        display: block;
        margin: 0 auto;
        text-align: center;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 30px;
      }
    }
  }
}

//咨询热线
.zx-sec{
  margin-top: 151px;
  height: 300px;
  width: 100%;
  background: url('../../../static/mobile/aboutUs/img_bg.png') no-repeat center;
  background-size: cover;
  padding:  53px 154px 63px 147px;
  box-sizing: border-box;
  .zx-sec-con{
    .zx-sec-block:nth-child(1){
      margin-bottom: 28px;
    }
    .zx-sec-block{
      display: flex;
      img{
        width: 60px;
        height: 60px;
        margin-top: 5px;
      }
      div{
        margin-left: 24px;
        span{
          display: block;
          text-align: left;
          color: #FFFFFF;
        }
        span:nth-child(1){
          font-size: 24px;
          margin-bottom: 4px;
        }
        span:nth-child(2){
          font-size: 24px;
          font-weight: 500;
          font-size: 36px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mContactUs_aboutUser.vue